var render, staticRenderFns
import script from "./FrsFieldSelection.vue?vue&type=script&lang=js&"
export * from "./FrsFieldSelection.vue?vue&type=script&lang=js&"
import style0 from "./FrsFieldSelection.vue?vue&type=style&index=0&id=64d07ade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d07ade",
  null
  
)

export default component.exports